export const ticket_promotion_mechanics = [
  'spend_and_get',
  'spend_and_get_percent',
  'cashback_percent',
  'cashback_money',
  'spend_and_get_gift',
]